module.exports = __webpack_public_path__ + "img/awaitingPayment.86fb154f.png";